import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider, Protected } from "@/context/AuthContext";
import { AccountProvider, RequireAccount } from "@/context/AccountContext";
import { initLenis, resetScroll } from "@/lib/lenis";
import { Cursor } from "@/components/site/Cursor";
import Home from "@/pages/Home";
import PaymentResult from "@/pages/PaymentResult";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Legal from "@/pages/Legal";
import ProductPage from "@/pages/ProductPage";
import AccountLogin from "@/pages/account/AccountLogin";
import AccountRegister from "@/pages/account/AccountRegister";
import ForgotPassword from "@/pages/account/ForgotPassword";
import ResetPassword from "@/pages/account/ResetPassword";
import VerifyEmail from "@/pages/account/VerifyEmail";
import AccountProfile from "@/pages/account/AccountProfile";

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    resetScroll();
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => initLenis(), []);

  return (
    <CartProvider>
      <AccountProvider>
      <BrowserRouter>
        <ScrollReset />
        <div className="relative min-h-screen bg-ink font-body text-bone">
          <div aria-hidden className="grain pointer-events-none fixed inset-0 z-[60] opacity-[0.06] mix-blend-overlay" />
          <Cursor />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/payment/success" element={<PaymentResult outcome="success" />} />
            <Route path="/payment/cancel" element={<PaymentResult outcome="cancel" />} />
            <Route path="/condizioni" element={<Legal />} />
            <Route path="/prodotto/:slug" element={<ProductPage />} />
            <Route path="/account" element={<RequireAccount><AccountProfile /></RequireAccount>} />
            <Route path="/account/accedi" element={<AccountLogin />} />
            <Route path="/account/registrati" element={<AccountRegister />} />
            <Route path="/account/password-dimenticata" element={<ForgotPassword />} />
            <Route path="/account/reimposta-password" element={<ResetPassword />} />
            <Route path="/account/verifica-email" element={<VerifyEmail />} />
            <Route path="/admin/login" element={<AuthProvider><AdminLogin /></AuthProvider>} />
            <Route path="/admin" element={<AuthProvider><Protected><AdminDashboard /></Protected></AuthProvider>} />
          </Routes>
          <Toaster theme="dark" position="bottom-left" toastOptions={{ className: "sfu-toast" }} />
        </div>
      </BrowserRouter>
      </AccountProvider>
    </CartProvider>
  );
}

export default App;
